import React from 'react';
import { Container, Typography } from '@mui/material';

const ClientsPage: React.FC = () => {
  return (
    <Container>
      <Typography variant="h4">Clients</Typography>
      <Typography>Client management functionality coming soon...</Typography>
    </Container>
  );
};

export default ClientsPage;